import Slides from "./Slides";
import Text from "./Text";


function Home() {
    return(
        <div>
        <Text/>
        <Slides/>
        </div>
        
    )
}

export default Home;